import axios from "axios";
import { createContext, useState } from "react";
import { ApiCallGateway } from "../Network/apiCallGateway";
import { decrypt } from "../Utils/crypto.utils";

export const DataContext = createContext();

export const DataContextProvider = ({ children }) => {
  const [postData, setPostData] = useState([]);
  const [folderDetails, setFolderDetails] = useState({});
  const [passwordAccess, setPasswordAccess] = useState({});
  const [envAccess, setEnvAccess] = useState({});
  const [folderAccess, setFolderAccess] = useState({});
  const [loader, setLoader] = useState(false);
  const [isShared, setIsShared] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [adminViewUser, setAdminViewUser] = useState({});
  const [breadCrumb, setBrudCrumb] = useState([]);
  const [logsData,setLogsData] =useState([])
  const [sidebarSelected, setSidebarSelected] = useState("");

  const handleCheckboxChange = (itemId) => {
    if (selectedItems.includes(itemId)) {
      setSelectedItems(selectedItems.filter((id) => id !== itemId));
    } else {
      setSelectedItems([...selectedItems, itemId]);
    }
  };
  const handleSelectUsers = (user) => {
    if (!selectedUsers.includes(user)) {
      setSelectedUsers((oldValue) => [...oldValue, user]);
    }
  };
  const handleSelectowner = (user) => {
    if (!selectedUsers.includes(user)) {
      setSelectedUsers([user]);
    }
  };
  const removeSelectUsers = (user) => {
    if (selectedUsers.includes(user)) {
      setSelectedUsers(selectedUsers.filter((u) => u !== user));
    }
  };

  const handleSelectAll = (passwordList) => {
    if (selectedItems.length === passwordList?.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(passwordList?.map((item) => item._id));
    }
  };

  const getPasswordAccessList = async (pId, eId, fId) => {
    setLoader(true);
    const access =
      await ApiCallGateway.permission.getPasswordPermission(
        pId,
        eId,
        fId
      );
    // console.log(access)
    if (access?.status === 200) {
      setLoader(false);
      setPasswordAccess(access?.data);
      return access?.data;
    } else {
      setLoader(false);
      return [];
    }
  };
  const getEnvAccessList = async (eId, fId) => {
    setLoader(true);
    const access =
      await ApiCallGateway.permission.getEnvPermissionList(eId, fId);
    if (access?.status === 200) {
      setLoader(false);
      setEnvAccess(access?.data);
      return access?.data;
    } else {
      setLoader(false);
      return [];
    }
  };
  const getLogs = async (dataId,action,pageNumber,userId) => {
    setLoader(true);
    const logs =
      await ApiCallGateway.logs.getLogs(dataId,action,pageNumber,userId);
    if (logs?.status === 200) {
      setLoader(false);
      setLogsData(logs?.data);
      return logs?.data;
    } else {
      setLoader(false);
      return [];
    }
  };
  const getFolderAccessList = async (fId) => {
    setLoader(true);
    const access =
      await ApiCallGateway.permission.getFolderPermission(fId);
    // console.log(access);
    if (access?.status === 200) {
      setLoader(false);
      setFolderAccess(access?.data);
      return access?.data;
    } else {
      setLoader(false);
      return [];
    }
  };
  const getPasswordVault = async (passwordId) => {
    setLoader(true);
    try {
      const passwordData = await ApiCallGateway.password.getAPassword(
        passwordId
      );
      const res = await decrypt(passwordData?.data?.Data?.stdout);
      const p = JSON.parse(res);
      console.log(p)
      const password = decrypt(p?.data?.data?.password);
      console.log(password)
      setLoader(false);
      return password || p?.data?.data?.password;
    } catch (err) {
      setLoader(false);
      console.log(err);
    }
  };

  const deletePermission = async (shareId, permissionId) => {
    console.log(shareId, permissionId);
    setLoader(true);
    try {
      const res = await ApiCallGateway.permission.deletePermission(
        shareId,
        permissionId
      );
      console.log(res);
      setLoader(false);
      return res;
    } catch (err) {
      setLoader(false);
      console.log(err);
    }
  };
  const updatePermission = async (request, permissionId) => {
    setLoader(true);
    try {
      const res = await ApiCallGateway.permission.updatePermission(
        request,
        permissionId
      );
      setLoader(false);
      console.log(res);
      return res;
    } catch (err) {
      setLoader(false);
      console.log(err);
    }
  };
  const createPermission = async (body) => {
    setLoader(true);
    try {
      const res = await ApiCallGateway.permission.createPermision(
        body
      );
      setLoader(false);
      return res;
    } catch (err) {
      setLoader(false);
      console.log(err);
    }
  };

  const value = {
    postData,
    setPostData,
    folderDetails,
    setFolderDetails,
    getPasswordAccessList,
    getEnvAccessList,
    getFolderAccessList,
    passwordAccess,
    envAccess,
    folderAccess,
    loader,
    setLoader,
    setIsShared,
    isShared,
    getPasswordVault,
    handleCheckboxChange,
    selectedItems,
    selectedUsers,
    handleSelectUsers,
    handleSelectowner,
    removeSelectUsers,
    handleSelectAll,
    setSelectedItems,
    setSelectedUsers,
    deletePermission,
    updatePermission,
    createPermission,
    setAdminViewUser,
    adminViewUser,
    breadCrumb,
    setBrudCrumb,
    sidebarSelected,
    setSidebarSelected,getLogs,logsData,
  };
  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
};
